import { AlreadyTranslated } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ExperienceResource } from '../../../../../../Types';
import HighlightUnlicensed from './HighlightUnlicensed';

interface Props {
  experienceResource: ExperienceResource;
}

const ExperienceRowItems: React.FC<Props> = ({ experienceResource }) => (
  <td className="w-full">
    <div className="flex justify-between">
      <p className="text-sm ">
        <AlreadyTranslated content={experienceResource.payload.title} />
      </p>
      <HighlightUnlicensed experienceResource={experienceResource} />
    </div>
  </td>
);

export default observer(ExperienceRowItems);
